export default [
    {
        month: "jan",
        number: 1
    },
    {
        month: "feb",
        number: 2
    },
    {
        month: "mar",
        number: 3
    },
    {
        month: "apr",
        number: 4
    },
    {
        month: "may",
        number: 5
    },
    {
        month: "jun",
        number: 6
    },
    {
        month: "jul",
        number: 7
    },
    {
        month: "aug",
        number: 8
    },
    {
        month: "sep",
        number: 9
    },
    {
        month: "oct",
        number: 10
    },
    {
        month: "nov",
        number: 11
    },
    {
        month: "dec",
        number: 12
    },
]